module.exports = __webpack_public_path__ + "static/media/logo_emina_grey.69894154.png";